<template>
<div class="content" v-if="dataReady">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header my-2">
				<h1>
					Семейство: {{ registration.name }}
					<span
						v-if="registration.status !== 'approved'"
						:class="'badge badge-' + {new: 'info', edited: 'success', rejected: 'danger'}[registration.status]">
							{{ $t('status.family_' + registration.status) }}
					</span>
				</h1>
				<div class="pull-right" v-if="registration.status === 'new' || registration.status === 'edited'">
					<button type="button" class="btn btn-primary" data-toggle="tooltip" title="Одобрявам" @click="approveRegistration()"><i class="fa fa-check"></i></button>
					<button type="button" class="btn btn-danger" data-toggle="tooltip" title="Не одобрявам" @click="rejectRegistration()"><i class="fa fa-close"></i></button>
				</div>
				<p v-if="registration.status !== 'approved' && registration.statusComment">
					Това семейство е {{ $t('status.family_' + registration.status).toLowerCase() }} с причина: <strong>"{{registration.statusComment}}"</strong>
				</p>
			</div>
		</div>
	</section>

	<!-- Main Content -->
	<div class="container-fluid">

	<div class="card">
		<div class="card-block">
			<h4 class="card-title">Бележка към администратора: </h4>
			<p class="about-text">{{ registration.note }}</p>
		</div>
	</div>
	<div>
	<ul class="nav nav-pills md-pills" role="tablist">
		<li class="nav-item"><a class="nav-link active" data-toggle="tab" role="tab" href="#basic">Профил</a></li>
		<li class="nav-item"><a class="nav-link" data-toggle="tab" role="tab" href="#about">За нас</a></li>
	</ul>
	</div>

	<div class="tab-content">
			<!-- Basic Info -->
			<div role="tabpanel" class="tab-pane active" id="basic">
				<div class="card">
					<div class="card-block">
						<div class="row">
							<div class="col-sm-6">
								<div class="p-10">
									<h4>Родители</h4>
									<div class="table-responsive">
										<table class="table table-hover">
											<tbody>
												<tr>
													<td><strong>Баща</strong></td>
													<td>{{ fatherInfo.name }}</td>
													<td>{{ fatherInfo.interests }}</td>
												</tr>
												<tr>
													<td><strong>Майка</strong></td>
													<td>{{ motherInfo.name }}</td>
													<td>{{ motherInfo.interests }}</td>
												</tr>
											</tbody>
										</table>
									</div>

									<hr>

									<h4>Деца</h4>

									<div class="table-responsive">
										<table class="table table-hover">
											<tbody>
												<tr v-for="(child, key) in familyChildren">
													<td><strong>{{ $config.lists.childRoles[ familyChildren[key].role ].text }}</strong></td>
													<td>{{ familyChildren[key].name }}</td>
													<td>{{ getChildAge(familyChildren[key]) }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>

								<hr>

								<div class="p-10">
									<h4>Контакт</h4>

									<div class="table-responsive">
										<table class="table">
											<tbody>
												<tr>
														<td><strong>Адрес</strong></td>
														<td>{{ $config.lists.countries[registration.country].text }} / {{ $config.lists.states[registration.state].text }} / {{ registration.city }}</td>
												</tr>
												<tr>
													<td><strong>E-mail</strong></td>
													<td><a :href="'mailto:' + registration.user.email">{{ registration.user.email }}</a></td>
												</tr>
											</tbody>
										</table>
								</div>
							</div>

						</div> <!-- col-sm-6 end -->

							<div class="col-sm-6">
								<div class="card-img">
									<img class="img-thumbnail family-photo" :src="registration.photo || '/network/static/img/default_family_photo.jpg'">
								</div>
								<div class="mt-1" v-if="registration.info.interests">
									<h4 class="card-title">Интереси</h4>
									<button class="btn btn-light-green btn-tag" v-for="interest in registration.info.interests.split(',')">{{ interest }}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> <!-- end tab basic -->

			<div role="tabpanel" class="tab-pane" id="about">
				<div class="card">
					<div class="card-block">
						<h4 class="card-title">Накратко за нашето семейство</h4>
						<div class="p-10 about-text">
							{{ this.registration.info.about }}
						</div>

						<h4 class="card-title">Опит</h4>
						<p class="card-text">{{ registration.info.hsExperience }} години</p>

						<h4 class="card-title">Методи</h4>
						<table class="table table-responsive">
								<tbody>
									<tr v-for="method in registration.info.hsMethods">
										<td><strong>{{ $config.lists.hsmethods[method].name }}</strong></td>
										<td>{{ $config.lists.hsmethods[method].desc }}</td>
									</tr>
								</tbody>
						</table>
					</div>

				</div>
			</div>

		</div> <!-- end tab-content -->

	</div>
</div>

</template>

<script>
module.exports = {
	data: function () {
		return {
			registration: {},
			role: 'father',
			fatherInfo: {},
			motherInfo: {},
			familyChildren: [],
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		getChildAge: function (child) {
			var currentYear = new Date().getFullYear();
			return (currentYear - child.birthYear) + ' год.';
		},
		goBack: function () {
			this.$router.push('/family');
		},
		fetchData: function () {
			var familyUserId = 0;
			var familyId = 0;
			if (this.$route.params.id === 'me') {
				familyUserId = this.$root.user.familyUser.id;
				familyId = this.$root.user.familyUser.family.id;
			} else {
				familyId = this.$route.params.id;
			}
			this.$http.get('backend://registration/' + familyId).then((response) => {
				this.registration = response.body;

				this.fatherInfo = { name: '', role: 'father', interests: '', birthYear: 0, id: 0 };
				this.motherInfo = { name: '', role: 'mother', interests: '', birthYear: 0, id: 0 };

				for (var i = 0; i < this.registration.users.length; i++) {
					var oMember = this.registration.users[ i ];
					if (oMember.user === familyUserId) {
						this.role = oMember.role;
					}
					if (oMember.role === 'father') {
						this.fatherInfo = oMember;
					} else if (oMember.role === 'mother') {
						this.motherInfo = oMember;
					} else {
						this.familyChildren.push(oMember);
					}
				}
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		rejectRegistration: function () {
			if (!confirm('Сигурни ли сте че не искате да одобрите това семейство?')) {
				return;
			}
			var comment = prompt('Моля, дайте причина за вашето неодобрение:');

			this.$http.post('backend://registration/' + this.registration.id + '/reject', {statusComment: comment}).then((response) => {
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		approveRegistration: function (status) {
			if (!confirm('Сигурни ли сте че искате да одобрите това семейство?')) {
				return;
			}

			this.$http.post('backend://registration/' + this.registration.id + '/approve').then((response) => {
				this.$router.push('/family/' + response.body.id);
			}).catch(this.$http.toastCatcher);
		}
	}
};
</script>
<style>
.about-text {
	white-space: pre-wrap;
	word-wrap: break-word;
	font-family: inherit;
}
.family-photo {
	max-height: 300px;
}
</style>



// WEBPACK FOOTER //
// RegistrationView.vue?3cb95e86